// import Formatter from './formatter.js';
import Color from './color.js'

/**
 * 数字相关操作
 */

function Num() {}

/**
 * 校验金额有效性
 * @param {*} num
 * @returns
 */
Num.isAmountValid = function (num) {
  var reg = /^([1-9][\d]{0,20})(\.[\d]{1,2})?$/
  var reg2 = /^(0\.[1-9][0-9]?)|(0\.0[1-9])$/
  return reg.test(num) || reg2.test(num)
}

/**
 * 判断是否数字
 * @param {*} value
 * @returns
 */
Num.isNumber = function (value) {
  return !isNaN(parseFloat(value)) && isFinite(value)
}

/**
 * 千分位转换方法
 * @param num 要转换的数字
 * @param cent  保留的小数位数
 */
Num.toThousands = function (num = 0, cent = 2) {
  num = parseFloat(num).toFixed(cent)
  let numArr = num.toString().split('.')

  if (numArr.length === 1) {
    return numArr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  }
  return numArr[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + numArr[1]
}

/**
 * 获取有效数字
 * @param {number} num
 * @param {number} maxFractionDigits 最大分位位数
 */
Num.validNumber = function (num, maxFractionDigits = 2) {
  let curAmount = '' + num
  // 先把非数字的都替换掉，除了数字和.
  curAmount = curAmount.replace(/[^\d.]/g, '')
  // 必须保证第一个为数字而不是.
  curAmount = curAmount.replace(/^\./g, '')
  // 最多只能输入到亿
  curAmount = curAmount.replace(/(\d{9})(\d+)/, '$1')
  // 删除第一个数字为0
  curAmount = curAmount.replace(/(^0)(\w+)/g, '$2')
  // 保证只有出现一个.而没有多个.
  // curAmount = curAmount.replace(/\.{2,}/g, ".");
  // 保证.只出现一次，而不能出现两次以上
  curAmount = curAmount
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.')

  //需要保留小数
  if (maxFractionDigits > 0) {
    const reg = new RegExp('(\\.[\\d]{' + maxFractionDigits + '})(\\d)')
    curAmount = curAmount.replace(reg, '$1')
  } else {
    curAmount = curAmount.split('.')[0]
  }

  return curAmount
}

/**
 * 数字转百分比 0.1 -> 10%
 * @param {number} num
 * @param {number} cent
 * @param {number} needRound 是否要四舍五入
 */
Num.num2Percentage = function (num = 0, cent = 2, needRound = true) {
  return `${Num.vnum4Percentage(num * 100, cent, needRound)}%`
}

/**
 * 保留四位小数的方法
 * @param {number} num
 * @param {number} cent
 * @param {number} needRound 是否要四舍五入
 */
Num.vnum4Percentage = function (num = 0, cent = 4, needRound = true) {
  if (needRound) {
    return `${(num * 1).toFixed(cent)}`
  }

  let numStr = num.toString()
  let index = numStr.indexOf('.')
  if (index !== -1) {
    numStr = numStr.substring(0, cent + index + 1)
  } else {
    numStr = numStr.substring(0)
  }
  return `${parseFloat(numStr).toFixed(cent)}`
}

/**
 * 安全保留小数的方法 - 即如果本身小数位超过要求位数就不做处理，不足则补0
 * @param {number} num
 * @param {number} cent
 * @param {number} needRound 是否要四舍五入
 */
Num.vnum2SafePercentage = function (num = 0, cent = 2) {
  let numStr = num.toString()
  let parts = numStr.split('.')
  let floatDigit = 0

  if (!parts[1]) {
    floatDigit = cent
  } else if (parts[1].length < cent) {
    floatDigit = cent - parts[1].length
  }
  if (floatDigit > 0) {
    for (let i = 0; i < floatDigit; i++) {
      parts[1] = (parts[1] || '') + '0'
    }
  }
  return parts.join('.')
}

/**
 * 基金收益率格式化
 */
Num.numberFormatterWithSign = function (num, len = 2, options = {}) {
  let result = {
    value: '—',
    color: '#333333'
  }

  Object.assign(result, options)

  if ((typeof num === 'number' || typeof num === 'string') && num) {
    num = parseFloat(num).toFixed(len)

    if (num > 0) {
      result.value = '+' + Num.toThousands(num, len) + '%'
      result.color = Color.getColor(num)
    } else if (num < 0) {
      result.value = Num.toThousands(num, len) + '%'
      result.color = Color.getColor(num)
    } else {
      result.value = Num.toThousands(num, len) + '%'
      result.color = Color.getColor(num)
    }
  }
  return result
}
/**
 * 基金收益率格式化
 * str1代表收益率大于0要赋值的class类名
 * str2代表收益率小于0要赋值的class类名
 * str3代表收益率等于0或者不存在要赋值的class类名
 */
Num.numberFormatterWithClass = function (
  num,
  len = 2,
  str1 = 'red_style',
  str2 = 'green_style',
  str3 = 'default_style'
) {
  let result = {}
  if ((typeof num === 'number' || typeof num === 'string') && num) {
    num = parseFloat(num).toFixed(len)

    if (num > 0) {
      result.value = '+' + Num.toThousands(num, len) + '%'
      result.className = str1
    } else if (num < 0) {
      result.value = Num.toThousands(num, len) + '%'
      result.className = str2
    } else {
      result.value = Num.toThousands(num, len) + '%'
      result.className = str3
    }
  }
  return result
}

/**
 * 数字千分位格式化
 * @param num: 需要格式化的数字
 * @param len: 保留小数位长度
 * @param opts: 可选项-自定义默认值
 * @returns {{color: string, colorHex: string, value: string}}
 */
Num.numberFormatter = function (num, len = 2, options = {}) {
  let result = {
    value: '--',
    color: '#333333'
  }

  Object.assign(result, options)

  if (typeof num === 'number' || typeof num === 'string') {
    num = parseFloat(num).toFixed(len)

    if (num > 0) {
      result.value = '+' + Num.toThousands(num, len)
      result.color = Color.getColor(num)
    } else if (num < 0) {
      result.value = Num.toThousands(num, len)
      result.color = Color.getColor(num)
    } else {
      result.value = Num.toThousands(num, len)
      result.color = Color.getColor(num)
    }
  }
  return result
}

/**
 * tool
 *  对比当前版本和最新版本
 *    2、当前版本 < 配置版本
      1、当前版本 = 配置版本
      0、当前版本 > 配置版本
 */
Num.compareVersion = function (currentVersion, lastVersion) {
  let returnFlag = '0' //返回值，默认当前版本最大
  console.log('num,对比当前版本和最新版本', currentVersion, lastVersion)
  try {
    //格式：版本号 Android/4.0.1     H5/4.0.1
    currentVersion = currentVersion.split('/')
    lastVersion = lastVersion.split('/')
    //取值：版本号 4.0.1
    currentVersion = currentVersion[currentVersion.length - 1]
    lastVersion = lastVersion[lastVersion.length - 1]

    //拆分.成数组[4,0,1]
    let array_c = currentVersion.split('.')
    let array_l = lastVersion.split('.')
    //判断大小：大版本
    if (array_l[0] > array_c[0]) {
      returnFlag = '2'
    }
    //判断大小：中版本
    if (array_l[0] == array_c[0] && array_l[1] > array_c[1]) {
      returnFlag = '2'
    }
    //判断大小：小版本
    if (
      array_l[0] == array_c[0] &&
      array_l[1] == array_c[1] &&
      array_l[2] > array_c[2]
    ) {
      returnFlag = '2'
    }
    //判断大小：相同版本
    if (
      array_l[0] == array_c[0] &&
      array_l[1] == array_c[1] &&
      array_l[2] == array_c[2]
    ) {
      returnFlag = '1'
    }
  } catch (error) {
    console.error('对比当前版本和最新版本：异常')
  }

  return returnFlag
}

export default Num



// WEBPACK FOOTER //
// ./src/utils/num.js